// Portal "My roadmap" (More > My roadmap, /portal/my-roadmap).
//
// Owner ask 2026-10-15: "show the whole roadmap, scope-based. for now,
// everyone sees the roadmap for all teams, just like the main roadmap admins
// see, and can filter to mine." So a roadmap reader (roadmap:read — every
// role's default for now — exec:portal or ADMIN) gets the SAME page
// leadership opens at /roadmap, with the "Mine" chip in its filter bar and
// without the leadership-only run reports; the access rule is in
// roadmap/roadmapAccess.ts, the twin of the API's gates. An account without
// the scope keeps the personal slice (MyRoadmapSlice).

import { useAuth } from '../../context/AuthContext';
import { RoadmapReportsPage } from '../RoadmapReportsPage';
import { roadmapAccess } from '../roadmap/roadmapAccess';
import { MyRoadmapSlice } from './MyRoadmapSlice';

export default function MyRoadmapPage() {
  const { reader } = roadmapAccess(useAuth());
  return reader ? <RoadmapReportsPage /> : <MyRoadmapSlice />;
}
